import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ReactLoading from "react-loading";
import trash from "./../../../../Assets/Images/trash.png";
import upload from "../../../../Assets/Images/upload.png";
import Navbar from "../../../../Components/Navbar/Navbar";
import "./../PurchaseRequest.css";
import { Fragment } from "react";
import InputError from "../../../../Components/InputError/InputError";
import { Upload} from "antd";
import Moment from "moment";
import { getBranchId, getType, numberFormat, numberFormatInt, refreshPage, toastStyle } from "../../../../Helpers/Utils/Common";
import { createPurchaseRequest, getPurchaseRequest, updatePurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi";
import { validatePurchaseRequest } from "../../../../Helpers/Validation/Purchase/PurchaseRequestValidation";
import { getDepartment } from "../../../../Helpers/apiCalls/departmentApi";
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi";
import noDataImg from "../../../../Assets/Images/no-data-img.png";
import Modal from "antd/es/modal/Modal";
import Compressor from "compressorjs";
import FileExceedModal from "../../../../Components/Modals/FileExceedModal";
import { getAllBranches } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import Footer from "../../../../Components/Footer/Footer";
const { Dragger } = Upload;

function EditPurchaseRequest({edit}) {
    const { id } = useParams();
    const accountType = getType();
    let navigate = useNavigate();
    const [inactive, setInactive] = useState(true);
    const [isChanged, setIsChanged] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isClickedSave, setIsClickedSave] = useState(false);
    const [items, setItems] = useState([]);
    const [allDepartment, setAllDepartment] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    const [allOIC, setAllOIC] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
    const [allBranches, setAllBranches] = useState([]);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        department_id: false,
        request_date: false,
        required_date: false,
        quantity: false,
        itemList: false,
    });
    const [addDetails, setAddDetails] = useState({
        name: "",
        description: "",
        branch: "",
        department_id: "1",
        requested_by: "1",
        request_date: Moment(new Date(), 'YYYY-MM-DD').format('yyyy-MM-DD'),
        pr_no: ""
    })
    
    //DISABLE SCROLL FUNCTION
    function limitScroll() {
        var numericInputs = document.querySelectorAll(".numeric-input");
        numericInputs.forEach(function (input) {
        input.addEventListener("wheel", function (e) {
            e.preventDefault();
        });
        });
    }
    limitScroll();
    
    const handleAddChange = (e, type) => {
        if(type === "select") {
            setAddDetails((prevState) => ({
                ...prevState,
                [e.for]: e.value,
                [e.select_value]: {
                    for: e.for,
                    label: e.label,
                    value: e.value,
                }
            }));
        } else {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
            }));
        }
    }

    function handleAddItem() {
        const newItem =  { item: "", qty: 0, current_qty: 0, uom: "", remarks: "", classification: "item", purchase_request_remark: "", price: 0, total: 0 };
        setItems((prevItems) => [...prevItems, newItem]);
    }

    function handleItemsChange(e, row, select) {
        setIsChanged(true);
        var temp = items;
        if (select) {
            temp[row].item_id_value = { label: e.label, value: e.value };
            temp[row].item_id = e.value;

        } else {
            const { name, value } = e.target;
            temp[row][name] = value;
            if (name === "quantity" || name === "selling_price") {
                var quantity = temp[row].quantity ? temp[row].quantity : 0
                var price = temp[row].selling_price ? temp[row].selling_price : 0
                var total = quantity * price;
                temp[row]["total"] = total;
            }
            
        }
        setItems(temp);
        setTimeout(() => setIsChanged(false), 1);
    }

    function handleRemoveItem(row) {
        setIsChanged(true);

        const updatedOrderList = [...items];
        updatedOrderList.splice(row, 1);
        setItems(updatedOrderList);

        setTimeout(() => setIsChanged(false), 10);
    }

    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }
    

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th className="color-gray">
                            quantity
                        </th>
                        <th className="color-gray">
                            unit
                        </th>
                        <th className="color-gray">
                            complete item description
                        </th>
                        <th className="color-gray">
                            selling price
                        </th>
                        <th className="color-gray">
                            remarks
                        </th>
                        <th className="color-gray">
                            action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => {
                        return (
                            <tr key={item.id}>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="quantity"
                                        className="hide-spinner numeric-input"
                                        value={item.quantity}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    <InputError  isValid={isError.quantity} message={"Input is Required"}/>
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="uom"
                                        value={item.uom}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    <InputError  isValid={isError.item_id} message={"Input is Required"}/>
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="description"
                                        value={item.description}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    
                                    {/* <Select
                                        options={itemsOptions}
                                        defaultValue={item.item_id_value}
                                        name="item_id"
                                        placeholder="Choose item"
                                        onChange={(e) =>
                                            handleItemsChange(e, index, true)
                                        }
                                        search={true}
                                    /> */}
                                    <InputError  isValid={isError.item_id} message={"Input is Required"}/>
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="selling_price"
                                        className="hide-spinner numeric-input"
                                        value={item.selling_price}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    <InputError  isValid={isError.item_id} message={"Input is Required"}/>
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="remark"
                                        value={item.remark}
                                        onChange={(e) =>
                                            handleItemsChange(e, index, false)
                                        }
                                    />
                                    <InputError  isValid={isError.item_id} message={"Input is Required"}/>
                                </td>
                                <td>
                                    <img
                                        src={trash}
                                        alt="trash"
                                        onClick={() => handleRemoveItem(index)}
                                        className="cursor-pointer"
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };
    
    const handleRemove = (selectedFile) => {

        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    async function fetchPurchaseRequest() {
        setPrevAttachments([]);
        setAddDetails([]);
        const response = await getPurchaseRequest({id: id});
        if(response.data) {
            // const variantImages = await Promise.all(
            //     response.data.data[0].purchase_request_attachments?.map(async (image) => {
            //         const response = await fetch(image.file_url);
            //         const blob = await response.blob();
            //         const fileName = image.file_name;
        
            //         return {
            //         id: image.id,
            //         uid: image.id, // Use an appropriate property for the uid
            //         preview: image.file_url,
            //         name: fileName,
            //         status: "done",
            //         url: image.file_url,
            //         file: new File([blob], fileName, { type: blob.type }),
            //         };
            //     })
            //     );
            //     setFileList(variantImages);
            var data = response.data.data.map((data) => {
                var info = data;
                info.branch = data.branch
                info.department_id_value = {
                    label: data.department_name,
                    value: data.department_id,
                }
                info.employee_id_value = {
                    label: data.requested_by_name,
                    value: data.requested_by,
                }
                info.oic_id_value = {
                    label: data.oic,
                    value: data.oic,
                }
                info.branch_id_value = {
                    label: data.branch,
                    value: data.branch_id,
                }
                return info
            })
            setAddDetails(data[0]);
            var itemsdata = data[0].purchase_request_items.map((data) => {
                var info = data;
                info.item_id_value = {
                    label: data.item_name,
                    value: data.item_id,
                }
                return info
            })
            setItems(itemsdata);
            setPrevAttachments(response.data.data[0].purchase_request_attachments);
        }
        
    }

    async function fetchDepartment() {
        setAllDepartment([]);
        const response = await getDepartment({});
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data;
                info.for = "department_id";
                info.select_value = "department_id_value";
                info.label = data.name;
                info.value = data.id;
                return info
            })
            setAllDepartment(data);
        }
    }

    async function fetchEmployees() {
        setAllEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data?.data.map((data) => {
                var info = data;
                info.for = "requested_by";
                info.select_value = "employee_id_value";
                info.label = data.first_name + " " + data.last_name;
                info.value = data.id;
                return info
            })
            setAllEmployees(data);

            var oic = response.data.data.filter((data) => { return data.employee_type === "officer in charge"})
            .map((data) => {
                var info = data;
                info.for = "oic";
                info.select_value = "oic_id_value";
                info.label = data.first_name + " " + data.last_name;
                info.value = data.first_name + " " + data.last_name;
                return info
            })
            setAllOIC(oic);
        }
    }

    async function handleSubmit() {
        if (validatePurchaseRequest(addDetails, items, setIsError)) {
            setIsClicked(true);
            addDetails.is_save = 0;
            addDetails.prev_files = prevAttachments
            const response = await updatePurchaseRequest(addDetails, items, fileList, "submitted");
            if(response.data) {   
                toast.success(response.data.message, { style: toastStyle() }); 
                setTimeout(() => {
                    navigate("/purchaserequest/review/" + id);
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } else {
            toast.error('PLEASE FILL IN ALL REQUIRED FIELDS!', { style: toastStyle() });   
        }
    }

    async function handleSave() {
        if (validatePurchaseRequest(addDetails, items, setIsError)) {
            setIsClickedSave(true);
            addDetails.is_save = 0;
            const response = await updatePurchaseRequest(addDetails, items, fileList, "pending");
            if(response.data) {
                toast.success('SUCCESSFULY UPDATED PURCHASE ORDER!', { style: toastStyle() });    
                setTimeout(() => {
                    navigate("/purchaserequest/review/" + id);
                }, 1000);
            } else {
                toast.error('Something went wrong!', { style: toastStyle() });
                setTimeout(() => {
                    // refreshPage()
                }, 1000);
            }
        } else {
            toast.error('PLEASE FILL IN ALL REQUIRED FIELDS!',
            { autoClose: 2000, hideProgressBar: true, theme:"colored" });
        }
    }

    async function fetchBranches() {
        setAllBranches([]);
        const response = await getAllBranches();

        if (response.data) {
            var tempBranches = response.data.data.map((branch) => {
                var info = {};
                    info.for = "branch_id";
                    info.select_value = "branch_id_value";
                    info.label = branch.name;
                    info.value = branch.id;
                return info
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = tempBranches.filter((data) => {
                return data.value === getBranchId()
                })
                setAllBranches(filteredBranch);
            } else {
                setAllBranches([{label: "All Branches", value:""}, ...tempBranches]);
            }
        } 
    }

    useEffect(() => {
        fetchPurchaseRequest()
        fetchDepartment()
        fetchEmployees()
        fetchBranches()
    }, [] )

    useEffect(() => {
        var _subtotal = items
        .map((item) => parseFloat(item.total))
        .reduce((a, b) => a + b, 0);

        var _grandTotal = _subtotal;
        setAddDetails((prev) => {
            return {
                ...prev,
                subtotal: _subtotal.toFixed(2),
                grand_total: _grandTotal.toFixed(2),
            };
        });
    }, [isChanged]);

    return (
        <div>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PURCHASES"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> EDIT PURCHASE REQUEST </h1>
                    </Col>
                </Row>

                {/* content */}
                <div className="edit-form">
                    <Row className="mb-3">
                        <Col xs={12} lg={6}>
                        <span className="edit-label">
                                Department Name{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Department..."
                                value={addDetails.department_id_value}
                                options={allDepartment}
                                onChange={(e) => handleAddChange(e, "select")}
                            />
                            <InputError
                                isValid={isError.department_id}
                                message={"Deparment Name is required"}
                            />
                        </Col>

                        <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <span className="edit-label">
                                Request Date{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Form.Control
                                type="date"
                                name="request_date"
                                className="nc-modal-custom-text"
                                value={addDetails.request_date}
                                onChange={(e) => handleAddChange(e)}
                            />
                            <InputError
                                isValid={isError.request_date}
                                message={"Request date is required"}
                            />
                        </Col>
                        <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <span className="edit-label">
                                Required Date{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Form.Control
                                type="date"
                                name="required_date"
                                className="nc-modal-custom-input"
                                defaultValue={addDetails.required_date}
                                onChange={(e) => handleAddChange(e)}
                            />
                            <InputError
                                isValid={isError.required_date}
                                message={"Required date is required"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={4}>
                        <span className="edit-label ">OIC/Head</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Employee..."
                                value={addDetails.oic_id_value}
                                options={allOIC}
                                onChange={(e) =>
                                    handleAddChange(e, "select")
                                }
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                        <span className="edit-label ">Branch</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Branch..."
                                value={addDetails.branch_id_value}
                                options={allBranches}
                                onChange={(e) => handleAddChange(e, "select")}
                            />
                            {/* <Form.Control
                                type="text"
                                name="branch"
                                value={addDetails.branch}
                                className="nc-modal-custom-input"
                                // disabled
                                onChange={(e) => handleAddChange(e)}
                            /> */}
                        </Col>
                        <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                        <span className="edit-label">
                                Requested by{" "}
                                <label className="badge-required">{` *`}</label>
                            </span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select Employee..."
                                value={addDetails.employee_id_value}
                                options={allEmployees}
                                onChange={(e) =>
                                    handleAddChange(e, "select")
                                }
                            />
                            <InputError
                                isValid={isError.employee_id}
                                message={"Employee is required"}
                            />
                        </Col>
{/*                        <Col xs={4}>
                            <Form.Control
                                type="text"
                                name="pr_no"
                                className="nc-modal-custom-input"
                                value={addDetails.pr_no}
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>*/}
                    </Row>

                    <Row className="mt-4 mb-2">
                        <Col xs={12}>
                            <span className="edit-label">
                                Remarks
                                <span className="edit-optional px-2">
                                    (Optional)
                                </span>
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Form.Control
                                type="text"
                                name="remarks"
                                className="nc-modal-custom-input"
                                value={addDetails.remarks}
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4 pt-3">
                        <Col>
                        <span className="edit-label mb-2">
                            Particulars{" "}
                            <label className="badge-required">{` *`}</label>
                        </span>
                        <div className="edit-purchased-items">
                            {items.length === 0 ? (
                                <span>No Particular Found!</span>
                            ) : (
                                renderTable()
                            )}
                            <InputError
                                isValid={isError.itemList}
                                message={
                                    "You must add at least 1 item"
                                }
                            />
                        </div>
                        </Col>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Col>
                        <Button
                            type="button"
                            onClick={() => handleAddItem()}
                            // disabled={branchValue.value === "" ? true : false}
                        >
                            Add Item
                        </Button>
                        </Col>
                    </Row>
                    <div className="mt-4 noPrint mx-3">
                        <Row className="review-data mb-2">
                            FILE ATTACHMENTS
                        </Row>
                        <Row className="">
                            {
                                prevAttachments && prevAttachments.map((attachment) => (
                                    <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                        <img src={attachment.file_url}  className="img-preview"/>
                                    </Col>
                                ))
                            }
                            {
                                !prevAttachments || prevAttachments.length === 0 && 
                                <Col xs={1}>
                                <div className="no-data-cont d-flex justify-content-left preview-container">
                                    <img src={noDataImg} alt="no data found" className="img-preview"/>
                                </div>
                                </Col>
                            }
                        </Row>
                    </div>
                    <Row className="mt-4 pt-3">
                        <Col xs={12}>
                            {/* <Dragger
                                {...{
                                // style: { width: 550 },
                                file,
                                defaultFileList: file,
                                onRemove: handleRemove,
                                beforeUpload: handleBeforeUpload,
                                multiple: false,
                                // onChange: handleOnChange,
                                listType: "picture",
                                progress: { showInfo: true },
                                }}
                            >
                                <img
                                    src={upload}
                                    className="cursor-pointer"
                                />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger> */}
                            <Dragger
                                fileList={fileList}
                                onRemove={handleRemove}
                                beforeUpload={handleBeforeUpload}
                                multiple={false}
                                listType="picture"
                                progress={{ showInfo: true }}
                            >
                                <img src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>

                    {/* <Row className="align-right pt-3">
                            <Col xs={2} className="text-end">
                                <span className="edit-label color-gray">
                                    Subtotal
                                </span>
                            </Col>
                            <Col xs={1} className="text-end">
                                <span className="edit-label align-middle">
                                    PHP
                                </span>
                            </Col>
                            <Col xs={3} className="text-end">
                                <span className="edit-label align-middle">
                                    {numberFormat(addDetails.subtotal)}
                                </span>
                            </Col>
                        </Row>
                    <Row className="align-right pt-3">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray">
                                Delivery/Service Fee
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle">PHP</span>
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                type="number"
                                name="service_fee"
                                min={0}
                                step="0.01"
                                className="align-middle nc-modal-custom-text"
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row>

                    <Row className="align-right pt-3">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray">
                                Discount
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle">PHP</span>
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                type="number"
                                name="discount"
                                min={0}
                                step="0.01"
                                className="align-middle nc-modal-custom-text"
                                onChange={(e) => handleAddChange(e)}
                            />
                        </Col>
                    </Row>

                    <Row className="align-right py-5">
                        <Col xs={2} className="text-end">
                            <span className="edit-label color-gray grand-total-text">
                                Grand Total
                            </span>
                        </Col>
                        <Col xs={1} className="text-end">
                            <span className="edit-label align-middle grand-total-text">
                                PHP
                            </span>
                        </Col>
                        <Col xs={3} className="text-end">
                            <span className="edit-label align-middle grand-total-text">
                                {"PHP " + numberFormat(addDetails.grand_total)} 
                            </span>
                        </Col>
                    </Row> */}
                    
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate("/purchaserequest/review/" + id)}
                        >
                            Cancel
                        </button>
                        {
                            addDetails.status === "pending" && (
                                <>
                                {isClickedSave ? (
                                    <div className="button-tertiary me-3 d-flex justify-content-center">
                                        <ReactLoading
                                            type="bubbles"
                                            color="#FFFFFF"
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={handleSave}
                                    >
                                        Save
                                    </button>
                                )}
                                </>
                            )
                        }
                        {isClicked ? (
                            <div className="button-primary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            </div>
            
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                    <div className="mt-2 d-flex justify-content-center">
                        <img
                            src={trash}
                            alt="trash"
                            onClick={() => handleRemoveItemAttachment(previewFile)}
                            className="cursor-pointer"
                        />
                    </div>
                </Row>
            </Modal>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );

}

export default EditPurchaseRequest;
